export default [
  {
    path: '/credential-management',
    name: 'CredentialManagement',
    component: () => import('@/views/pages/management-admin/credential-management/Index.vue'),
    meta: {
      name: 'Credential Management',
      resource: 'Kelola User - Credential Management',
      navActiveLink: 'credential-management',
      action: 'manage',
    },
  },
]
